import { atom, useAtom, useAtomValue } from 'jotai';

export const isFromEventGroupAtom = atom<boolean>(false);

export const useIsFromEventGroupValue = () => {
  return useAtomValue(isFromEventGroupAtom);
};

export const useIsFromEventGroup = () => {
  return useAtom(isFromEventGroupAtom);
};
